var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByUsingCaradvise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by-using-caradvise_svg__clip0_23940_40145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.334,
    y: 0.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by-using-caradvise_svg__clip1_23940_40145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.479 29.404h-.434V17.538a6.867 6.867 0 00-6.867-6.867H19.04a6.867 6.867 0 00-6.867 6.867v65.095A6.867 6.867 0 0019.04 89.5H44.18a6.867 6.867 0 006.867-6.867V37.85h.433v-8.446z",
    fill: "#303133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.646 17.08v66.013A5.208 5.208 0 0144.44 88.3H18.785a5.21 5.21 0 01-5.21-5.209V17.08a5.21 5.21 0 015.21-5.207h3.112a2.475 2.475 0 002.291 3.409h14.626a2.476 2.476 0 002.29-3.41h3.334a5.208 5.208 0 015.208 5.207v.001z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.913 84.855H16.309a.987.987 0 01-.986-.986V19.531a.986.986 0 01.986-.986h30.604a.987.987 0 01.985.986v64.338a.987.987 0 01-.985.986z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.494 40.267a8.432 8.432 0 100-16.864 8.432 8.432 0 000 16.864z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.378 39.126a7.29 7.29 0 100-14.581 7.29 7.29 0 000 14.58z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.905 43.101H24.413a.548.548 0 000 1.096h13.492a.548.548 0 100-1.096zM39.725 45.95H22.462a.548.548 0 100 1.096h17.263a.548.548 0 000-1.096zM44.078 54.134H19.143a.464.464 0 00-.463.464v24.935c0 .256.207.463.463.463h24.935a.464.464 0 00.464-.463V54.598a.464.464 0 00-.464-.464z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.859 54.681H19.09V79.45h24.768V54.681z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47 57.072h-8.916a.362.362 0 100 .724h8.916a.362.362 0 100-.724z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.717 59.2H24.554a.362.362 0 100 .724h14.163a.362.362 0 000-.725z",
    fill: "#E95832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.117 61.225H24.708a.362.362 0 100 .725h11.409a.362.362 0 100-.725z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by-using-caradvise_svg__clip2_23940_40145)",
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.315 32.809l-.029.083-.026.073a1.72 1.72 0 01-.733.873c-.425.261-.91.35-1.44.267-.688-.11-1.2-.491-1.524-1.135-.304-.605-.341-1.254-.112-1.929.061-.18.141-.346.238-.496l.01-.01a2.03 2.03 0 01.194-.254h-1.519l-.002.004h-1.573l.191.504c.166.437.584.726 1.05.727 0 .002.012.003.028.003-.034.375-.01.76.07 1.153a3.281 3.281 0 001.135 1.888c.343.289.732.499 1.153.625.333.1.675.149 1.024.149.267 0 .54-.03.815-.088.88-.188 1.53-.685 1.988-1.52l.022-.04-.96-.877zM28.576 29.541h3.799c.314 0 .635.073.955.215.429.191.731.508.899.94l.934-.86a2.762 2.762 0 00-1.016-.969 3.507 3.507 0 00-1.318-.407 4.913 4.913 0 00-.558-.024h-4.765l.158.419c.146.385.506.654.912.687"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.834,
    y: 1,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "#3C3C3C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "by-using-caradvise_svg__clip0_23940_40145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.334,
    y: 0.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by-using-caradvise_svg__clip1_23940_40145"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.334 10.67)",
    d: "M0 0h49.5v78.829H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by-using-caradvise_svg__clip2_23940_40145"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(27.506 27.944)",
    d: "M0 0h7.883v7.883H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/by-using-caradvise.632a1bf3.svg";
export { SvgByUsingCaradvise as ReactComponent };